import React from 'react';
import { withTranslation } from 'react-i18next';

import Heading from '../../components/heading/heading';

import { Row, Col, Button } from 'react-bootstrap';

import './benefitscontent.scss';

class BenefitsContent extends React.Component {
  render() {
    const SPAN = 8;
    const LEFT = 0;
    const RIGHT = 4;
    const { t } = this.props;

    return (
      <>
      <Row>
      <Col>


    <Heading as="h1" className="page">{t('Benefits._headline')}</Heading>

    </Col>
    </Row>

    <Row>
    <Col md={{span:SPAN, offset: LEFT}} className="benefit">
      <Heading as="h2">{t('Benefits.no_calorie_counting_headline')}</Heading>
      <p>{t('Benefits.no_calorie_counting_body')}</p>
    </Col>

    <Col md={{span:SPAN, offset: RIGHT}} className="benefit">
      <Heading as="h2">{t('Benefits.no_guessing_headline')}</Heading>
      <p>{t('Benefits.no_guessing_body')}</p>
    </Col>

    <Col md={{span:SPAN, offset: LEFT}} className="benefit">
      <Heading as="h2">{t('Benefits.eat_what_you_like_headline')}</Heading>
      <p>{t('Benefits.eat_what_you_like_body')}</p>
      
    </Col>
    <Col md={{span:SPAN, offset: RIGHT}} className="benefit">
      <Heading as="h2">{t('Benefits.avoid_binges_headline')}</Heading>
      <p>{t('Benefits.avoid_binges_body')}</p>
      
    </Col>

    <Col md={{span:SPAN, offset: LEFT}} className="benefit">
      <Heading as="h2">{t('Benefits.keep_track_headline')}</Heading>
      <p>{t('Benefits.keep_track_body')}</p>
      
    </Col>


    <Col md={{span:SPAN, offset: RIGHT}} className="benefit">
      <Heading as="h2">{t('Benefits.keep_progress_headline')}</Heading>
      <p>{t('Benefits.keep_progress_body')}</p>
      
    </Col>

    <Col md={{span:SPAN, offset: LEFT}} className="benefit">
      <Heading as="h2">{t('Benefits.keep_accountable_headline')}</Heading>
      <p>{t('Benefits.keep_accountable_body')}</p>
      
    </Col>



    </Row>

    <Row>
<Col>
<div style={{marginTop: "8rem", marginBottom: "8rem"}}>
    
    <div className="text-center">
      <div className="join-intro">{t('fragments.convinced_question')}</div>
    <Button href="https://app.nutrfy.com/signup" target="_blank" rel="noopener noreferrer" variant="primary" size="lg">
    {t('components.button_join')}</Button>
    </div>

    
  </div>
  </Col>
</Row>
</>
    )
  }
}
export default withTranslation()(BenefitsContent);